import { render, staticRenderFns } from "./remote_room.vue?vue&type=template&id=d50be340&scoped=true&"
import script from "./remote_room.vue?vue&type=script&lang=js&"
export * from "./remote_room.vue?vue&type=script&lang=js&"
import style0 from "./remote_room.vue?vue&type=style&index=0&id=d50be340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50be340",
  null
  
)

export default component.exports